'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

var _ = require('..');

var _reactSwipeable = require('react-swipeable');

var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  MainPanel: {
    displayName: 'MainPanel'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/MainPanel/MainPanel.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var MainPanel = _wrapComponent('MainPanel')((_dec = (0, _reactRedux.connect)(function (state) {
  return { data: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MainPanel, _Component);

  function MainPanel() {
    (0, _classCallCheck3.default)(this, MainPanel);
    return (0, _possibleConstructorReturn3.default)(this, (MainPanel.__proto__ || (0, _getPrototypeOf2.default)(MainPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(MainPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          onePanel = _props.onePanel; // eslint-disable-line no-shadow

      var ui = data.ui;
      // toto zajistí, že se levý okraj hlavního panelu posouvá doleva-doprava, v závislosti na levém panelu
      var myState = ui.subNavigationDisplay.replace(' ', '');
      // TODO: https://github.com/dbtek/bootstrap-vertical-tabs<br />
      var styles = require('./MainPanel.scss');

      // const onSwiping = (ev)=>{
      //   console.log(ev);
      // };

      return _react3.default.createElement(
        'main',
        { className: styles.agMainPanel + ' ' + styles[myState] + (onePanel ? ' ' + styles.onePanel : ''), itemProp: 'mainContentOfPage', itemScope: true, itemType: 'http://schema.org/WebPageElement' },
        _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            _.Scrollable,
            null,
            ' ',
            _react3.default.createElement(
              _reactSwipeable2.default,
              null,
              this.props.children
            )
          )
        )
      );
    }
  }]);
  return MainPanel;
}(_react2.Component), _class2.propTypes = {
  onePanel: _react2.PropTypes.bool,
  data: _react2.PropTypes.object,
  setUiProps: _react2.PropTypes.func.isRequired,
  children: _react3.default.PropTypes.oneOfType([_react3.default.PropTypes.arrayOf(_react3.default.PropTypes.node), _react3.default.PropTypes.node])
}, _temp)) || _class));

exports.default = MainPanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MainPanel/MainPanel.js
// module id = 1184
// module chunks = 0